export default __webpack_public_path__ + "static/media/LineChart.9d50ae76.mp4";